import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AppTab, TabService } from 'app/core/services/tab.service';
import { Observable } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss']
})
export class TabBarComponent implements OnInit {

  @ViewChild('tabInner') tabInner: ElementRef<HTMLElement>;

  tabs$: Observable<AppTab[]>;
  activeTab$: Observable<string>;

  contextMenuVisible = false;
  contextMenuX = 0;
  contextMenuY = 0;
  contextMenuPath = '';

  constructor(private tabService: TabService, private router: Router) {}

  ngOnInit(): void {
    this.tabs$ = this.tabService.tabs$;
    this.activeTab$ = this.tabService.activeTab$;
  }

  navigateTo(fullPath: string): void {
    this.router.navigateByUrl(fullPath);
  }

  close(event: MouseEvent, path: string): void {
    event.stopPropagation();
    this.tabService.closeTab(path);
  }

  scrollLeft(): void {
    this.tabInner?.nativeElement.scrollBy({ left: -160, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.tabInner?.nativeElement.scrollBy({ left: 160, behavior: 'smooth' });
  }

  onDrop(event: CdkDragDrop<AppTab[]>): void {
    const tabs = [...this.tabService.getTabsSnapshot()];
    moveItemInArray(tabs, event.previousIndex, event.currentIndex);
    this.tabService.setTabs(tabs);
  }

  onContextMenu(event: MouseEvent, path: string): void {
    event.preventDefault();
    event.stopPropagation();
    this.contextMenuPath = path;
    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;
    this.contextMenuVisible = true;
  }

  closeContextMenu(): void {
    this.contextMenuVisible = false;
  }

  ctxClose(): void {
    this.tabService.closeTab(this.contextMenuPath);
    this.closeContextMenu();
  }

  ctxCloseOthers(): void {
    this.tabService.closeOthers(this.contextMenuPath);
    this.closeContextMenu();
  }

  ctxCloseToLeft(): void {
    this.tabService.closeToLeft(this.contextMenuPath);
    this.closeContextMenu();
  }

  ctxCloseAll(): void {
    this.tabService.closeAll();
    this.closeContextMenu();
  }

  isFirstTab(): boolean {
    const tabs = this.tabService.getTabsSnapshot();
    return tabs.findIndex(t => t.path === this.contextMenuPath) === 0;
  }

  @HostListener('document:click')
  @HostListener('document:contextmenu')
  onDocumentClick(): void {
    this.closeContextMenu();
  }
}
